
export default {
	data() {
		return {
			defActive: '',
			getQuestionList: [], //问题列表
			questionDetails: {},
			viewer: {},
			id: null,
			defaultOpeneds: [],
			menuId: null,
			selectId: null
			// questionListNew: [], //新问题列表
			// navList: [],
		}
	},
	head() {
		return {
			title: '帮助中心-交易流程-盼之代售-手游网游账号买号卖号平台',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '盼之代售游戏交易平台帮助中心，游戏账号如何购买，游戏账号如何出售，游戏账号如何实名认证，游戏账号交易流程等等问题咨询解答。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: '帮助中心，游戏账号交易，盼之代售'
				}
			]
		}
	},
	methods: {
		// 联系客服
		ContactCustomer() {
			const info = {
				action: {
					event: 'CONSULT_SERVICE_GAME'
				}
			}
			this.$api.getRelatedClicks(info).then(res => {
				if (res.success) {
					this.$router.push('/services')
				}
			})
		},
		// 意见反馈
		Feedback() {
			this.$router.push({ path: '/advise' })
		},
		select(val) {
			this.selectId = val
		},
		handleOpen(key, keyPath) {
			this.menuId = key
		},
		getHelpDetail() {
			let id = this.defActive.split('-')
			let p = {
				action: {
					id: id[1]
				}
			}
			this.$api.questionDetail(p).then(res => {
				this.questionDetails = res.data
			})
		},
		questionsDetail(e) {
			this.questionDetails = e
			let p = {
				action: {
					id: e.id
				}
			}
			this.$api.questionDetail(p).then(res => {
				this.questionDetails = res.data
			})
		},
		questionList() {
			let p = {
				action: {
					includeNormal: true
				}
			}
			this.$api.questionList(p).then(res => {
				if (res.success) {
					this.getQuestionList = res.data.map(item => {
						return (item = { ...item, id: '100' + item.classifyId })
					})

					if (this.$route.params.id) {
						this.getQuestionList.map(item => {
							item.questionList.map(ele => {
								if (ele.id.toString() === this.$route.params.id) {
									this.menuId = item.id
									this.defActive = `${item.id}-${ele.id}`
								}
							})
						})
					} else {
						this.menuId = this.getQuestionList[0].id
						this.defActive = `${this.getQuestionList[0].id}-${res.data[0].questionList[0].id}`
					}
					this.getHelpDetail()
				}
			})
		}
	},
	mounted() {
		// if (this.$route.query.id) {
		// 	this.defActive = this.$route.query.id.toString();
		// }
		// this.questionListNews();
	},

	async created() {
		this.id = this.$route.params.id
		await this.questionList()
		// await this.getHelpDetail();
	},
	Updated() {
		// this.getHelpDetail();
	}
}
